import { IActionResponse } from "../../dal/BaseDAL";
import { getQueryString } from "../../logic/StringHelper";
import { ICollectionResponse } from "../../models/ICollectionResponse";
import { IWebhook, IWebhookActivity } from "../../models/Webhooks";
import api, { WEBHOOK_TYPE_TAG } from "../Api";

const webhooksApi = api.injectEndpoints({
    endpoints: (build) => ({
        getWebhooks: build.query<ICollectionResponse<IWebhook>, {page?: number, pageSize?: number}>({
            query: (arg) => '/webhooks' + getQueryString([].appendIfDefined(arg.page?.toString(), `page=${arg.page}`).appendIfDefined(arg.pageSize?.toString(), `pageSize=${arg.pageSize}`)),
            // The list is the only webhook query, and every mutation below can change what belongs in
            // it (a create adds a row, a delete removes one, a rename/enable changes one). A single
            // list tag is enough; there is no per-id query to invalidate more precisely.
            providesTags: [WEBHOOK_TYPE_TAG],
        }),
        createWebhook: build.mutation<IActionResponse, IWebhook>({
            query: (arg) => ({
                url: '/webhooks',
                method: 'POST',
                body: arg
            }),
            invalidatesTags: [WEBHOOK_TYPE_TAG],
        }),
        updateWebhook: build.mutation<IActionResponse, {data: IWebhook, id: string}>({
            query: (arg) => ({
                url: `/webhooks/${arg.id}`,
                method: 'POST',
                body: arg.data
            }),
            invalidatesTags: [WEBHOOK_TYPE_TAG],
        }),
        patchWebhook: build.mutation<IActionResponse, {data: IWebhook, id: string}>({
            query: (arg) => ({
                url: `/webhooks/${arg.id}`,
                method: 'PATCH',
                body: arg.data
            }),
            invalidatesTags: [WEBHOOK_TYPE_TAG],
        }),
        deleteWebhook: build.mutation<IActionResponse, {id: string}>({
            query: (arg) => ({
                url: `/webhooks/${arg.id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [WEBHOOK_TYPE_TAG],
        }),
        getWebhookActivities: build.query<ICollectionResponse<IWebhookActivity>, {id: string, count?: number}>({
            query: (arg) => `/webhooks/${arg.id}/activities` + getQueryString([].appendIfDefined(arg.count?.toString(), `count=${arg.count}`)),
        }),
        startWebhookDebug: build.mutation<IWebhook, {id: string}>({
            query: (arg) => ({
                url: `/webhooks/${arg.id}/debug/start`,
                method: 'POST',
            }),
            invalidatesTags: [WEBHOOK_TYPE_TAG],
        }),
        stopWebhookDebug: build.mutation<IWebhook, {id: string}>({
            query: (arg) => ({
                url: `/webhooks/${arg.id}/debug/stop`,
                method: 'POST',
            }),
            invalidatesTags: [WEBHOOK_TYPE_TAG],
        })
    })
})

export const {
   useGetWebhooksQuery,
   useCreateWebhookMutation,
   useUpdateWebhookMutation,
   usePatchWebhookMutation,
   useDeleteWebhookMutation,
   useGetWebhookActivitiesQuery,
   useStartWebhookDebugMutation,
   useStopWebhookDebugMutation,
} = webhooksApi;